












import Vue from 'vue'
import { CHART_SIZE } from '../sizes'

export default Vue.extend({
  name: 'Title',
  data: () => ({ CHART_SIZE }),
})
